{
  "static-content-download-app": {
    "buttons": {},
    "text": {
      "title": "Download Beauty Booking app",
      "description": "Our software is designed to make your life easier. So why wait? Download our App today and start living a more organized and stress-free life!"
    }
  }
}
